/** Shared bottom-right FAB hub for password reset, voice, and AI chat. */
export const FAB_BOTTOM = 28;
export const FAB_EDGE = 28;
export const FAB_GAP = 12;
export const FAB_SIZE = 52;

/** Vertical stack above the main hub button (0 = closest to main). */
export function fabVerticalOffset(index) {
  return FAB_BOTTOM + (index + 1) * (FAB_SIZE + FAB_GAP);
}

export const PANEL_BOTTOM = FAB_BOTTOM + FAB_SIZE + FAB_GAP;
export const PANEL_RIGHT = FAB_EDGE;
